<template>
  <div class="mb-5">
    <div
      v-for="(image, index) in images"
      :key="index"
      class="flex flex-col gap-3 mb-5"
    >
      <label :for="'iamges-' + index"
        >Hình sản phẩm {{ index + 1 }}
        <span v-show="!image" class="error">*</span></label
      >
      <FilePond
        aria-required="true"
        :ref="'pond' + index"
        :name="'images[' + index + ']'"
        label-idle="Drop files here..."
        :server="server"
        accepted-file-types="image/jpeg, image/png, image/webp"
        @update:files="updateFiles($event, index)"
      >
      </FilePond>
      <input
        type="hidden"
        :name="'images[]'"
        :value="image"
        v-if="image"
      />
    </div>
    <button
      type="button"
      @click="addImage"
      class="p-3 bg-green-300 text-black rounded"
      name="themsp"
      id="submit-btn"
    >
      <span class="fa-solid fa-file-arrow-down"></span> Thêm hình phụ sản phẩm
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const images = ref([''])

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
const server = {
  process: {
    url: '/api/images-multi',
    method: 'POST',
    headers: csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {},
    onload: (response) => {
      const data = JSON.parse(response)
      const path = data?.paths?.[0] ?? data?.path ?? ''
      return path
    },
  },
}

const updateFiles = (fileItems, index) => {
  if (fileItems.length > 0) {
    const file = fileItems[0]
    images.value[index] = file.serverId || ''
  } else {
    images.value[index] = ''
  }
}

const addImage = () => {
  images.value.push('')
}
</script>

<script>
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)
</script>

<style scoped>
@import 'filepond/dist/filepond.min.css';
@import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
</style>
